var reComment = /\/\*[\s\S]*?\*\//g;
var reDeclaration = /([^:;\s]+?)\s*:\s*((?:[^;"']+|"(?:[^"\\]|\\.|url\([^)]*\))*"|'(?:[^'\\]|\\.|url\([^)]*\))*'|url\(\s*(?:[^'")\s]+|'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*")\s*\))*?)(?=;|$)/gi;
/**
 * Parse inline styles string into object.
 *
 * @param styleString - inline styles string
 * @returns object with styles
 */
export function parseInlineStyles(styleString) {
    var styleObject = {};
    var input = (styleString || '').replace(reComment, '');
    var match = reDeclaration.exec(input), property, value;
    while (match !== null) {
        property = match[1].trim();
        value = match[2].trim();
        styleObject[property] = value;
        match = reDeclaration.exec(input);
    }
    return styleObject;
}
